import { AddNewModal } from "./AddNewModal";

export default AddNewModal;
